module.exports = __webpack_public_path__ + "static/media/proceso-04-entregamos.95e557d6.svg";